export const targetGroupsByRegionConstants = {
  TARGET_GROUPS_BY_REGION_LOADING: "TARGET_GROUPS_BY_REGION_LOADING",
  TARGET_GROUPS_BY_REGION_SUCCESS: "TARGET_GROUPS_BY_REGION_SUCCESS",
  TARGET_GROUPS_BY_REGION_FAILURE: "TARGET_GROUPS_BY_REGION_FAILURE",
};

export const createTargetGroupsByRegionConstants = {
  CREATE_TARGET_GROUPS_BY_REGION_LOADING:
    "CREATE_TARGET_GROUPS_BY_REGION_LOADING",
  CREATE_TARGET_GROUPS_BY_REGION_SUCCESS:
    "CREATE_TARGET_GROUPS_BY_REGION_SUCCESS",
  CREATE_TARGET_GROUPS_BY_REGION_FAILURE:
    "CREATE_TARGET_GROUPS_BY_REGION_FAILURE",
};

export const editTargetGroupsByRegionConstants = {
  EDIT_TARGET_GROUPS_BY_REGION_LOADING: "EDIT_TARGET_GROUPS_BY_REGION_LOADING",
  EDIT_TARGET_GROUPS_BY_REGION_SUCCESS: "EDIT_TARGET_GROUPS_BY_REGION_SUCCESS",
  EDIT_TARGET_GROUPS_BY_REGION_FAILURE: "EDIT_TARGET_GROUPS_BY_REGION_FAILURE",
};

export const deleteTargetGroupsByRegionConstants = {
  DELETE_TARGET_GROUPS_BY_REGION_LOADING:
    "DELETE_TARGET_GROUPS_BY_REGION_LOADING",
  DELETE_TARGET_GROUPS_BY_REGION_SUCCESS:
    "DELETE_TARGET_GROUPS_BY_REGION_SUCCESS",
  DELETE_TARGET_GROUPS_BY_REGION_FAILURE:
    "DELETE_TARGET_GROUPS_BY_REGION_FAILURE",
};

export const addTargetGroupsByRegionConstants = {
  ADD_TARGET_GROUPS_BY_REGION_LOADING: "ADD_TARGET_GROUPS_BY_REGION_LOADING",
  ADD_TARGET_GROUPS_BY_REGION_SUCCESS: "ADD_TARGET_GROUPS_BY_REGION_SUCCESS",
  ADD_TARGET_GROUPS_BY_REGION_FAILURE: "ADD_TARGET_GROUPS_BY_REGION_FAILURE",
};

export const removeTargetGroupsByRegionConstants = {
  REMOVE_TARGET_GROUPS_BY_REGION_LOADING:
    "REMOVE_TARGET_GROUPS_BY_REGION_LOADING",
  REMOVE_TARGET_GROUPS_BY_REGION_SUCCESS:
    "REMOVE_TARGET_GROUPS_BY_REGION_SUCCESS",
  REMOVE_TARGET_GROUPS_BY_REGION_FAILURE:
    "REMOVE_TARGET_GROUPS_BY_REGION_FAILURE",
};
